// src/pages/restaurant-tables/AfricanTables.jsx
import React from 'react';
import LocationTables from '../LocationTables';

const AfricanTables = () => {
  return <LocationTables locationKey="african" />;
};

export default AfricanTables;